module.exports = __webpack_public_path__ + "static/media/clock-regular.c9e83e09.svg";